module.exports = __webpack_public_path__ + "static/media/activity_type_taal.152ec115.svg";